export default "__VITE_ASSET__02b594cb__"